// React
import { useEffect, useState } from "react";
// Recoil
import {
  useRecoilValue,
  useSetRecoilState,
  useRecoilState,
  useResetRecoilState,
} from "recoil";
import {
  isMenuView,
  activeTable,
  tableOrderList,
  popupState,
} from "../../atom/pos";
//Components
import PosSideMenu from "./PosSideMenu";
import { PosPopupPay } from "./PosPopup";
// Assets
import { menuListData } from "../../assets/menuListData";
import { OrderTypes, menuListType } from "../../assets/Type";

function PosDetail() {
  // 포스 디테일 화면

  // Recoil State
  const isMenu = useRecoilValue(isMenuView);
  const popUp = useRecoilValue(popupState);

  return (
    <>
      <div className='table-detail-wrap'>
        {isMenu && <PosSideMenu />}
        <div className='table-detail-left'>
          <PosOrderList />
          <PosCustomerRequest />
          <div className='flex row' style={{ gap: "1%" }}>
            <PosTableInfo />
            <Calculator />
          </div>
        </div>
        <div className='table-detail-right'>
          <MenuLists />
          <ControlLists />
        </div>
      </div>
      {popUp === "cash" ? (
        <PosPopupPay type='cash' />
      ) : popUp === "credit" ? (
        <PosPopupPay type='credit' />
      ) : null}
    </>
  );
}

function PosOrderList() {
  // 포스 디테일 왼쪽 메뉴 리스트

  // Recoil State
  const tableNum = useRecoilValue(activeTable);
  const [orderList, setOrderList] = useRecoilState(tableOrderList);
  const listTitle = [
    "주문",
    "상품명",
    "수량",
    "단가",
    "할인금액",
    "금액",
    "비고",
  ];
  // useState
  const [selectList, setSelectList] = useState<number | null>(null);

  // Function
  const deleteMenu = (v: OrderTypes) => {
    const prevTableOrderList = [...orderList];
    const prevCurTableData = { ...orderList[tableNum - 1] };
    const prev = [...orderList[tableNum - 1].menu];
    const curValIdx = prev.findIndex((val) => val.name === v.name);
    prev.splice(curValIdx, 1);
    prevCurTableData.menu = prev;
    prevTableOrderList.splice(tableNum - 1, 1, prevCurTableData);
    setOrderList(prevTableOrderList);
  };

  return (
    <div className='ordered-list-wrap'>
      <div className='list-row'>
        {listTitle.map((v, i) => (
          <div key={i}>{v}</div>
        ))}
      </div>
      <div className='scroll'>
        {orderList[tableNum - 1].menu.map((v, i) =>
          selectList === i ? (
            <div
              className='list-active'
              key={i}
              onClick={() => {
                deleteMenu(v);
              }}
            >
              <div>{v.time}</div>
              <div>
                {v.name.length > 9 ? v.name.slice(0, 9) + "..." : v.name}
              </div>
              <div>{v.ea}</div>
              <div>{v.price.toLocaleString()}</div>
              <div>{v.sale}</div>
              <div>{v.total.toLocaleString()}</div>
              <div>{v.eta}</div>
            </div>
          ) : (
            <div
              className='list'
              key={i}
              onClick={() => {
                setSelectList(i);
              }}
            >
              <div>{v.time}</div>
              <div>
                {v.name.length > 9 ? v.name.slice(0, 9) + "..." : v.name}
              </div>
              <div>{v.ea}</div>
              <div>{v.price.toLocaleString()}</div>
              <div>{v.sale}</div>
              <div>{v.total.toLocaleString()}</div>
              <div>{v.eta}</div>
            </div>
          )
        )}
      </div>
    </div>
  );
}

function PosCustomerRequest() {
  // 포스 디테일 왼쪽 가운데 고객요청 부분
  // 고정 텍스트

  return (
    <div className='pos-customer-request-wrap'>
      <div className='pos-customer-request' style={{ borderBottom: "none" }}>
        <div className='pos-customer-title'>고객요청</div>
        <div className='pos-customer-content'>
          <span>젓가락1, 숟가락1</span>
          <span>18:00:51</span>
        </div>
      </div>
      <div className='pos-customer-request'>
        <div className='pos-customer-title'>메시지</div>

        <div className='pos-customer-content'>
          <span>내용</span>
          <span></span>
        </div>
      </div>
    </div>
  );
}
function PosTableInfo() {
  // 포스 디테일 왼쪽 하단 정보 부분

  // Recoil State
  const tableNum = useRecoilValue(activeTable);
  const orderList = useRecoilValue(tableOrderList);

  // Function
  const calcTotalAmount = () => {
    let amt = 0 as number;
    orderList[tableNum - 1].menu.reduce((acc, cur) => {
      amt = acc + cur.price * cur.ea;
      return amt;
    }, amt);
    return amt;
  };

  const calcTotalEa = () => {
    let total = 0 as number;
    orderList[tableNum - 1].menu.reduce((acc, cur) => {
      total = acc + cur.ea;
      return total;
    }, total);
    return total;
  };

  const payInfo = {
    ea: calcTotalEa(),
    total: calcTotalAmount(),
    sale: 0,
    membership: 0,
    order: calcTotalAmount(),
    receive: 0,
  };

  return (
    <div className='table-info-wrap'>
      <div className='taps'>
        <div className='tap tap-active'>결제정보</div>
        <div className='tap'>결제내역</div>
        <div className='tap' style={{ borderRight: "none" }}>
          고객정보
        </div>
      </div>
      <div className='info-content-wrap'>
        <div className='content'>
          <span>총 수량</span>
          <span>{payInfo.ea}</span>
        </div>
        <div className='content'>
          <span>총 매출액</span>
          <span>{payInfo.total.toLocaleString()}</span>
        </div>
        <div className='content'>
          <span>일반할인</span>
          <span>{payInfo.sale.toLocaleString()}</span>
        </div>
        <div className='content'>
          <span>멤버십할인</span>
          <span>{payInfo.membership.toLocaleString()}</span>
        </div>
        <div className='content'>
          <span>받을금액</span>
          <span>{payInfo.order.toLocaleString()}</span>
        </div>
        <div className='content'>
          <span>받은금액</span>
          <span>{payInfo.receive.toLocaleString()}</span>
        </div>
      </div>
    </div>
  );
}

function Calculator() {
  // 포스 디테일 왼쪽 하단 다이얼 부분

  // Recoil State
  const tableNum = useRecoilValue(activeTable);
  const [orderListData, setOrderListData] = useRecoilState(tableOrderList);

  // Function
  const resetMenu = () => {
    const prevOrderList = [...orderListData];
    prevOrderList.splice(tableNum - 1, 1, {
      num: tableNum,
      time: "",
      menu: [],
    });
    setOrderListData(prevOrderList);
  };

  const calcTotalAmount = () => {
    let amt = 0 as number;
    orderListData[tableNum - 1].menu.reduce((acc, cur) => {
      amt = acc + cur.price * cur.ea;
      return amt;
    }, amt);
    return amt;
  };

  return (
    <div className='calc-wrap'>
      <div className='calc-head'>{calcTotalAmount().toLocaleString()}</div>
      <div className='calc-body'>
        <div className='calc-row'>
          <div className='calc-btn roboto'>7</div>
          <div className='calc-btn roboto'>8</div>
          <div className='calc-btn roboto'>9</div>
          <div className='calc-btn roboto'>+</div>
        </div>
        <div className='calc-row'>
          <div className='calc-btn roboto'>4</div>
          <div className='calc-btn roboto'>5</div>
          <div className='calc-btn roboto'>6</div>
          <div className='calc-btn roboto'>-</div>
        </div>
        <div className='calc-row'>
          <div className='calc-btn roboto'>1</div>
          <div className='calc-btn roboto'>2</div>
          <div className='calc-btn roboto'>3</div>
          <div
            className='calc-btn2 pointer'
            onClick={() => {
              resetMenu();
            }}
          >
            전체
            <br />
            취소
          </div>
        </div>
        <div className='calc-row'>
          <div className='calc-btn roboto'>0</div>
          <div className='calc-btn roboto'>00</div>
          <div className='calc-btn roboto'>CLR</div>
          <div className='calc-btn2'>
            지정
            <br />
            취소
          </div>
        </div>
      </div>
    </div>
  );
}

function MenuLists() {
  // 포스 디테일 오른쪽 메뉴 리스트 부분

  // Recoil State
  const tableNum = useRecoilValue(activeTable);
  const [orderListData, setOrderListData] = useRecoilState(tableOrderList);
  const [temporaryOrderList, setTemporaryOrderList] = useState([
    ...orderListData[tableNum - 1].menu,
  ]);
  // useState
  const [selectMenu, setSelectMenu] = useState("추천메뉴");
  // const categoryList = ["전채요리", "주요요리", "버거", "파스타", "음료"];
  // 메뉴 변경
  const categoryList = [
    "추천메뉴",
    "덮밥",
    "짜글이",
    "추가",
    "사이드",
    "음료",
    "",
    "",
    "",
    "",
  ];

  // Function
  const orderMenu = (data: menuListType) => {
    const prevOrderList = [...orderListData];
    const prevMenu = [...prevOrderList[tableNum - 1].menu];
    const orderTime = `${
      new Date().getHours() < 10
        ? "0" + new Date().getHours()
        : new Date().getHours()
    }:${
      new Date().getMinutes() < 10
        ? "0" + new Date().getMinutes()
        : new Date().getMinutes()
    }:${
      new Date().getSeconds() < 10
        ? "0" + new Date().getSeconds()
        : new Date().getSeconds()
    }`;
    if (prevMenu.findIndex((menu) => menu.name === data.name) > -1) {
      prevMenu.splice(
        prevMenu.findIndex((menu) => menu.name === data.name),
        1,
        {
          time: orderTime,
          name: data.name,
          ea:
            prevMenu[prevMenu.findIndex((menu) => menu.name === data.name)].ea +
            1,
          price: data.price,
          sale: 0,
          total:
            data.price *
            (prevMenu[prevMenu.findIndex((menu) => menu.name === data.name)]
              .ea +
              1),
          eta: "-",
        }
      );
    } else {
      prevMenu.push({
        time: orderTime,
        name: data.name,
        ea: 1,
        price: data.price,
        sale: 0,
        total: data.price,
        eta: "-",
      });
    }
    if (prevOrderList[tableNum - 1].time) {
      prevOrderList.splice(tableNum - 1, 1, {
        ...prevOrderList[tableNum - 1],
        menu: prevMenu,
      });
    } else {
      prevOrderList.splice(tableNum - 1, 1, {
        ...prevOrderList[tableNum - 1],
        menu: prevMenu,
        time: orderTime,
      });
    }
    setOrderListData(prevOrderList);
  };

  useEffect(() => {}, [temporaryOrderList]);

  const returnList = (type: string) => {
    const selectList = menuListData.filter((v) => v.category === type);
    if (selectList.length < 30) {
      const addCount = 30 - selectList.length;
      for (var i = 0; i < addCount; i++) {
        selectList.push({
          category: type,
          bedg: [],
          img: "",
          isDescription: "",
          isDiscount: false,
          isOption: false,
          option: [],
          isSale: true,
          name: "",
          num: 0,
          price: 0,
          salePrice: 0,
        });
      }
    }
    return selectList.map((v, idx) =>
      v.category === selectMenu && v?.isSale === false ? (
        <div className='menu-list-btn3'>
          <span className='menu-name'>
            {v?.name.length > 7 ? v?.name.slice(0, 7) + "..." : v?.name}
          </span>
          <span className='soldout'>품절</span>
        </div>
      ) : v?.name ? (
        idx > 14 ? (
          <div
            className='menu-list-btn4 pointer'
            onClick={() => {
              orderMenu(v as menuListType);
            }}
          >
            <span className='menu-name'>
              {v?.name.length > 7 ? v?.name.slice(0, 7) + "..." : v?.name}
            </span>
            <span className='price'>{v?.price.toLocaleString()}</span>
          </div>
        ) : idx > 9 ? (
          <div
            className='menu-list-btn5 pointer'
            onClick={() => {
              orderMenu(v as menuListType);
            }}
          >
            <span className='menu-name'>
              {v?.name.length > 7 ? v?.name.slice(0, 7) + "..." : v?.name}
            </span>
            <span className='price'>{v?.price.toLocaleString()}</span>
          </div>
        ) : idx > 4 ? (
          <div
            className='menu-list-btn4 pointer'
            onClick={() => {
              orderMenu(v as menuListType);
            }}
          >
            <span className='menu-name'>
              {v?.name.length > 7 ? v?.name.slice(0, 7) + "..." : v?.name}
            </span>
            <span className='price'>{v?.price.toLocaleString()}</span>
          </div>
        ) : (
          <div
            className='menu-list-btn2 pointer'
            onClick={() => {
              orderMenu(v as menuListType);
            }}
          >
            <span className='menu-name'>
              {v?.name.length > 7 ? v?.name.slice(0, 7) + "..." : v?.name}
            </span>
            <span className='price'>{v?.price.toLocaleString()}</span>
          </div>
        )
      ) : (
        <div className='menu-list-btn'></div>
      )
    );
  };

  return (
    <div className='menu-list-wrap'>
      {categoryList.map((v, i) => {
        return v === selectMenu ? (
          <div
            className='menu-list-btn menu-active pointer'
            key={i}
            onClick={() => {
              setSelectMenu(v);
            }}
          >
            {v}
          </div>
        ) : (
          <div
            className='menu-list-btn pointer'
            key={i}
            onClick={() => {
              setSelectMenu(v);
            }}
          >
            {v}
          </div>
        );
      })}
      {returnList(selectMenu)}
    </div>
  );
}

function ControlLists() {
  // 포스 디테일 오른쪽 메뉴 하단 버튼 부분
  // Recoil State
  const setPopupState = useSetRecoilState(popupState);
  const resetTable = useResetRecoilState(activeTable);

  const list = [
    "주방메모",
    "주문",
    "COUPON",
    "간편결제",
    "현금",
    "멤버십",
    "할인",
    "상품옵션",
    "거래내역",
    "신용카드",
  ];

  return (
    <div className='control-list-wrap'>
      {list.map((v, i) =>
        v === "신용카드" ? (
          <button
            key={i}
            className='control-list-btn credit pointer'
            onClick={() => {
              setPopupState("credit");
            }}
          >
            {v}
          </button>
        ) : v === "현금" ? (
          <button
            key={i}
            className='control-list-btn pointer'
            onClick={() => {
              setPopupState("cash");
            }}
          >
            <img
              className='icon'
              src={"/assets/images/pos/cash.png"}
              alt='reauest'
              width={"36px"}
              height={"36px"}
              style={{ marginBottom: "4px" }}
            />
            {v}
          </button>
        ) : v === "주문" ? (
          <button
            key={i}
            className='control-list-btn pointer'
            onClick={() => {
              resetTable();
            }}
          >
            {v}
          </button>
        ) : (
          <button key={i} className='control-list-btn'>
            {v}
          </button>
        )
      )}
    </div>
  );
}
export default PosDetail;
